import { Block } from "../../models/block.interface";

export class ContactModel {
  name: string;
  rating: number;
  details: string;
  constructor(block: Block) {
    this.name = block.name;
    this.details = block.details;
    this.rating = 5;
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact-card/contact.model.ts